import React, { useState, useEffect } from "react";
import Title from "designs/v1/components/Title";
import {
  Button as BtButton,
  Modal,
  ModalBody,
  ModalHeader,
} from "react-bootstrap";
import Button from "designs/v1/components/Button";

export default function ESignature({ setStageScreen }) {
  const [showModal, setShowModal] = useState(true);

  const redirectToModification = () => {
    setStageScreen("ModificationType");
  };

  return (
    <React.Fragment>
      <Title title="Thank You!" />
      <div className="col-md-12 mt-3">
        <h3>
          eSign email is sent to your Inbox, please complete esign. Once done
          successfully, you will be notified by our team.
        </h3>
        <div className="mt-4">
          <Button
            type="button"
            title="Back To Home"
            handleClick={() => setStageScreen("")}
          />
        </div>
      </div>
      <Modal show={showModal}>
        <ModalHeader>
          <Modal.Title>Alert</Modal.Title>
        </ModalHeader>
        <ModalBody>
          <div>Do you want to modify your KYC details ?</div>
          <div className="row mt-4">
            <div className="col-md-6">
              <BtButton
                variant="light"
                onClick={() => setShowModal(false)}
              >
                No
              </BtButton>
            </div>
            <div className="col-md-6 text-end">
              <BtButton
                variant="primary"
                onClick={() => redirectToModification()}
              >
                Yes
              </BtButton>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}
